import React from 'react';

import Button from '../../../components/ui/Button';
import CompanyStatusBadge from './CompanyStatusBadge';
import CompanyActionsMenu from './CompanyActionsMenu';
import CopyLinkButton from './CopyLinkButton';

const CompanyTableMobile = ({ companies, onStatusToggle, onDuplicate }) => {
  const formatDate = (dateString) => {
    return new Date(dateString)?.toLocaleDateString('en-US', {
      month: 'short',
      day: 'numeric',
      year: 'numeric'
    });
  };

  const handleOpenLink = (url) => {
    window.open(url, '_blank', 'noopener,noreferrer');
  };

  return (
    <div className="space-y-4">
      {companies?.map((company) => {
        const visualizerUrl = `${window.location?.origin}/visualizer/${company?.slug}-${company?.id}`;
        const dashboardUrl = `${window.location?.origin}/client/${company?.slug}-${company?.id}`;
        const embedUrl = `${window.location?.origin}/embed/${company?.slug}-${company?.id}`;

        return (
          <div key={company?.id} className="bg-card border border-border rounded-lg p-4 space-y-3">
            <div className="flex items-start justify-between">
              <div className="flex items-center gap-3 flex-1">
                <div className="w-12 h-12 rounded-lg bg-primary/10 flex items-center justify-center text-primary font-semibold text-lg">
                  {company?.name?.charAt(0)?.toUpperCase()}
                </div>
                <div className="flex-1 min-w-0">
                  <div className="font-semibold text-text-primary truncate">{company?.name}</div>
                  <div className="text-xs text-text-secondary">{company?.slug}-{company?.id}</div>
                </div>
              </div>
              <CompanyActionsMenu
                company={company}
                onStatusToggle={onStatusToggle}
                onDuplicate={onDuplicate}
              />
            </div>
            <div className="flex items-center justify-between py-2 border-t border-border">
              <span className="text-sm text-text-secondary">Status</span>
              <CompanyStatusBadge status={company?.status} size="sm" />
            </div>
            <div className="flex items-center justify-between py-2 border-t border-border">
              <span className="text-sm text-text-secondary">Created</span>
              <span className="text-sm text-text-primary">{formatDate(company?.createdAt)}</span>
            </div>
            <div className="pt-2 border-t border-border space-y-2">
              <div className="text-xs font-medium text-text-secondary uppercase tracking-wider mb-2">
                Quick Links
              </div>
              
              <div className="flex items-center justify-between">
                <span className="text-sm text-text-secondary">Visualizer</span>
                <div className="flex items-center gap-1">
                  <CopyLinkButton url={visualizerUrl} label="Copy" variant="ghost" />
                  <Button
                    variant="ghost"
                    size="xs"
                    onClick={() => handleOpenLink(visualizerUrl)}
                    iconName="ExternalLink"
                    iconSize={12}
                  />
                </div>
              </div>

              <div className="flex items-center justify-between">
                <span className="text-sm text-text-secondary">Dashboard</span>
                <div className="flex items-center gap-1">
                  <CopyLinkButton url={dashboardUrl} label="Copy" variant="ghost" />
                  <Button
                    variant="ghost"
                    size="xs"
                    onClick={() => handleOpenLink(dashboardUrl)}
                    iconName="ExternalLink"
                    iconSize={12}
                  />
                </div>
              </div>

              <div className="flex items-center justify-between">
                <span className="text-sm text-text-secondary">Embed</span>
                <div className="flex items-center gap-1">
                  <CopyLinkButton url={embedUrl} label="Copy" variant="ghost" />
                  <Button
                    variant="ghost"
                    size="xs"
                    onClick={() => handleOpenLink(embedUrl)}
                    iconName="ExternalLink"
                    iconSize={12}
                  />
                </div>
              </div>
            </div>
          </div>
        );
      })}
    </div>
  );
};

export default CompanyTableMobile;